export class AlertMessage {
    type: string;
    message: string;
    params: string = null;
    status: string;
}

export class AlertResponse {
    alertId: number;
    title: string;
    alertType: string;
    description: string;
    publishDate: string;
}

export class Survey {
      surveyId: number;
      surveyTitle: string;
}
export class SurveyResponse {
    surveyId: number;
    surveyTitle: string;
}


